import { IActionResponse } from '../../dal/BaseDAL';
import { ISearchSettings } from '../../models/Settings';
import api from '../Api';

// Global product tags matching a term, for tag pickers (e.g. a nav pod's tag filter). The API
// takes a search term rather than listing every tag, so callers type-ahead against it.
export interface ITagsResponse {
    tags?: string[];
    userTags?: string[];
}

const searchSettingsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getSearchSettings: build.query<ISearchSettings, {org: string, user: string}>({
            query: () => 'search/settings',
        }),
        searchTags: build.query<ITagsResponse, {term: string}>({
            query: (arg) => `search/tags/search?tagSearchTerm=${encodeURIComponent(arg.term)}`,
        }),
        saveSearchSettings: build.mutation<IActionResponse, {data: ISearchSettings, org: string, user: string}>({
            query: (arg) => ({
                url: 'search/settings',
                method: 'POST',
                body: arg.data
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    searchSettingsApi.util.updateQueryData('getSearchSettings', {org: arg.org, user: arg.user}, draft => {
                        Object.assign(draft, arg.data);
                    })
                );
            },
        }),
        patchSearchSettings: build.mutation<IActionResponse, {data: Partial<ISearchSettings>, org: string, user: string}>({
            query: (arg) => ({
                url: 'search/settings',
                method: 'PATCH',
                body: arg.data
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    searchSettingsApi.util.updateQueryData('getSearchSettings', {org: arg.org, user: arg.user}, draft => {
                        Object.assign(draft, arg.data);
                    })
                );
            }
        })
    })
})

export const {
    useGetSearchSettingsQuery,
    useSearchTagsQuery,
    useSaveSearchSettingsMutation,
    usePatchSearchSettingsMutation,
} = searchSettingsApi;